export * from './newui/resources'
export * from './ui/resources'
export * from './mobile/resources'
export * from './tuqqi-talk/resources'